export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  link: string;
}

export interface GalleryCategory {
  id: string;
  name: string;
  desc: string;
  count: number;
  cover: string;
}

export interface GalleryItem {
  id: string;
  title: string;
  category: string;
  style: string;
  photographer: string;
  shootDate: string;
  hot: number;
  description: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    title: "春日花漾写真特辑",
    subtitle: "柔和光线与花瓣交织，定格最动人的春日瞬间",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20fashion%20portrait%20of%20a%20young%20asian%20woman%20with%20soft%20pink%20flowers%2C%20dreamy%20pastel%20background%2C%20soft%20natural%20lighting%2C%20editorial%20beauty%20photography%2C%20romantic%20spring%20mood%2C%20high%20detail%20cinematic&width=1920&height=1000&seq=bm-hero-01&orientation=landscape",
    link: "/gallery/detail/g01",
  },
  {
    id: "h2",
    title: "都市夜色街拍精选",
    subtitle: "霓虹与光影之间，捕捉都市女性的自信魅力",
    image:
      "https://readdy.ai/api/search-image?query=fashion%20street%20portrait%20of%20a%20stylish%20woman%20in%20a%20city%20at%20dusk%2C%20warm%20neon%20reflections%2C%20modern%20urban%20background%2C%20editorial%20photography%2C%20cinematic%20warm%20tones%2C%20high%20detail&width=1920&height=1000&seq=bm-hero-02&orientation=landscape",
    link: "/gallery/detail/g04",
  },
  {
    id: "h3",
    title: "高级质感棚拍写真",
    subtitle: "极简背景下的光影塑形，展现优雅与力量",
    image:
      "https://readdy.ai/api/search-image?query=high%20fashion%20studio%20portrait%20of%20an%20elegant%20woman%2C%20minimal%20beige%20backdrop%2C%20dramatic%20soft%20lighting%2C%20luxury%20editorial%20photography%2C%20refined%20composition%2C%20high%20detail&width=1920&height=1000&seq=bm-hero-03&orientation=landscape",
    link: "/gallery/detail/g07",
  },
  {
    id: "h4",
    title: "清新自然户外旅拍",
    subtitle: "海边与草地，记录最轻盈自在的笑容",
    image:
      "https://readdy.ai/api/search-image?query=natural%20outdoor%20portrait%20of%20a%20young%20woman%20on%20a%20seaside%20meadow%2C%20golden%20hour%20sunlight%2C%20soft%20green%20and%20sky%20tones%2C%20lifestyle%20photography%2C%20airy%20fresh%20mood%2C%20high%20detail&width=1920&height=1000&seq=bm-hero-04&orientation=landscape",
    link: "/gallery/detail/g10",
  },
  {
    id: "h5",
    title: "复古胶片质感合集",
    subtitle: "暖调颗粒与经典造型，重温旧时光的浪漫",
    image:
      "https://readdy.ai/api/search-image?query=retro%20film%20portrait%20of%20a%20woman%20with%20vintage%20styling%2C%20warm%20amber%20tones%2C%20grainy%20analog%20texture%2C%20classic%20elegant%20mood%2C%20editorial%20photography%2C%20high%20detail&width=1920&height=1000&seq=bm-hero-05&orientation=landscape",
    link: "/gallery/detail/g13",
  },
];

export const galleryCategories: GalleryCategory[] = [
  {
    id: "jp",
    name: "日系写真",
    desc: "清新自然，柔和通透的日式美学",
    count: 328,
    cover:
      "https://readdy.ai/api/search-image?query=bright%20airy%20japanese%20style%20portrait%20of%20a%20young%20woman%2C%20soft%20white%20and%20pale%20pink%20tone%2C%20gentle%20natural%20light%2C%20minimal%20clean%20background%2C%20editorial%20photography%2C%20high%20detail&width=700&height=900&seq=bm-cat-jp&orientation=portrait",
  },
  {
    id: "eu",
    name: "欧美风尚",
    desc: "大气性感，充满力量感的高级时装大片",
    count: 276,
    cover:
      "https://readdy.ai/api/search-image?query=glamorous%20european%20fashion%20portrait%20of%20a%20confident%20woman%2C%20elegant%20evening%20look%2C%20warm%20neutral%20studio%20backdrop%2C%20high%20fashion%20editorial%20photography%2C%20refined%20lighting%2C%20high%20detail&width=700&height=900&seq=bm-cat-eu&orientation=portrait",
  },
  {
    id: "street",
    name: "都市街拍",
    desc: "真实随性，捕捉城市中的时尚瞬间",
    count: 412,
    cover:
      "https://readdy.ai/api/search-image?query=candid%20urban%20street%20style%20portrait%20of%20a%20woman%20walking%20in%20the%20city%2C%20modern%20architecture%20background%2C%20natural%20daylight%2C%20fashion%20street%20photography%2C%20high%20detail&width=700&height=900&seq=bm-cat-street&orientation=portrait",
  },
  {
    id: "fresh",
    name: "清新自然",
    desc: "阳光绿意，最舒适的治愈系画面",
    count: 254,
    cover:
      "https://readdy.ai/api/search-image?query=fresh%20natural%20portrait%20of%20a%20smiling%20young%20woman%20in%20a%20sunny%20garden%2C%20soft%20green%20foliage%20background%2C%20warm%20sunlight%2C%20lifestyle%20photography%2C%20healing%20bright%20mood%2C%20high%20detail&width=700&height=900&seq=bm-cat-fresh&orientation=portrait",
  },
  {
    id: "retro",
    name: "复古典雅",
    desc: "胶片色调，经典造型的浪漫回响",
    count: 188,
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20elegant%20portrait%20of%20a%20woman%20with%20classic%20styling%2C%20warm%20amber%20film%20tones%2C%20retro%20interior%20background%2C%20analog%20textured%20photography%2C%20high%20detail&width=700&height=900&seq=bm-cat-retro&orientation=portrait",
  },
];

export const galleryItems: GalleryItem[] = [
  {
    id: "g01",
    title: "春日花漾 · 柔光人像",
    category: "jp",
    style: "日系写真",
    photographer: "林浅",
    shootDate: "2026-03-18",
    hot: 9820,
    description:
      "在铺满花影的午後，以柔和通透的自然光记录下春日里最轻盈的笑意。整体色调偏暖粉，突出皮肤的细腻光泽与画面的空气感。",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20fashion%20portrait%20of%20a%20young%20asian%20woman%20with%20soft%20pink%20flowers%2C%20dreamy%20pastel%20background%2C%20soft%20natural%20lighting%2C%20editorial%20beauty%20photography%2C%20romantic%20spring%20mood%2C%20high%20detail&width=800&height=1100&seq=bm-g01&orientation=portrait",
  },
  {
    id: "g02",
    title: "白墙咖啡馆 · 午后",
    category: "jp",
    style: "日系写真",
    photographer: "陈屿",
    shootDate: "2026-02-27",
    hot: 7640,
    description:
      "白墙、木桌与一杯拿铁，构成极简又温柔的日系场景。侧逆光勾勒出柔和的轮廓，让画面充满安静的生活气息。",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20japanese%20style%20portrait%20of%20a%20young%20woman%20in%20a%20white%20cafe%2C%20soft%20window%20light%2C%20clean%20pale%20background%2C%20airly%20natural%20photography%2C%20gentle%20mood%2C%20high%20detail&width=800&height=1100&seq=bm-g02&orientation=portrait",
  },
  {
    id: "g03",
    title: "浅色针织 · 温柔冬日",
    category: "jp",
    style: "日系写真",
    photographer: "苏念",
    shootDate: "2026-01-14",
    hot: 6980,
    description:
      "浅色针织衫与落地窗光影相映，用低对比的暖调呈现冬日的柔软与惬意，画面干净而富有层次。",
    image:
      "https://readdy.ai/api/search-image?query=soft%20cozy%20portrait%20of%20a%20young%20woman%20wearing%20a%20cream%20knitwear%20near%20a%20large%20window%2C%20warm%20winter%20light%2C%20minimal%20pale%20background%2C%20lifestyle%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g03&orientation=portrait",
  },
  {
    id: "g04",
    title: "都市夜色 · 霓虹漫步",
    category: "street",
    style: "都市街拍",
    photographer: "周野",
    shootDate: "2026-04-02",
    hot: 10420,
    description:
      "夜晚的城市是最天然的摄影棚。霓虹灯牌与车流虚化成的光斑，衬托出都市女性从容而自信的步伐。",
    image:
      "https://readdy.ai/api/search-image?query=fashion%20street%20portrait%20of%20a%20stylish%20woman%20in%20a%20city%20at%20night%2C%20warm%20neon%20light%20bokeh%2C%20modern%20urban%20background%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g04&orientation=portrait",
  },
  {
    id: "g05",
    title: "秋日街道 · 风衣look",
    category: "street",
    style: "都市街拍",
    photographer: "何晏",
    shootDate: "2025-11-09",
    hot: 8210,
    description:
      "经典卡其色风衣搭配落叶街道，用广角记录下城市秋日里随性又利落的时尚态度。",
    image:
      "https://readdy.ai/api/search-image?query=stylish%20autumn%20street%20portrait%20of%20a%20woman%20wearing%20a%20beige%20trench%20coat%2C%20fallen%20leaves%20city%20street%2C%20warm%20daylight%2C%20fashion%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g05&orientation=portrait",
  },
  {
    id: "g06",
    title: "地铁站台 · 通勤日常",
    category: "street",
    style: "都市街拍",
    photographer: "周野",
    shootDate: "2025-10-21",
    hot: 6120,
    description:
      "把镜头对准通勤路上的普通瞬间，整齐的线条与金属反光构成现代都市的几何美感。",
    image:
      "https://readdy.ai/api/search-image?query=candid%20commuter%20portrait%20of%20a%20woman%20on%20a%20modern%20metro%20platform%2C%20clean%20geometric%20architecture%2C%20cool%20neutral%20daylight%2C%20urban%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g06&orientation=portrait",
  },
  {
    id: "g07",
    title: "高级灰 · 棚拍质感",
    category: "eu",
    style: "欧美风尚",
    photographer: "Sam Wu",
    shootDate: "2026-03-05",
    hot: 11360,
    description:
      "极简高级灰背景搭配硬朗柔光，通过服装轮廓与人物神情的张力，呈现时装大片级别的质感。",
    image:
      "https://readdy.ai/api/search-image?query=high%20fashion%20studio%20portrait%20of%20an%20elegant%20woman%2C%20minimal%20grey%20backdrop%2C%20dramatic%20soft%20lighting%2C%20luxury%20editorial%20photography%2C%20refined%20composition%2C%20high%20detail&width=800&height=1100&seq=bm-g07&orientation=portrait",
  },
  {
    id: "g08",
    title: "暖调丝绒 · 复古回眸",
    category: "eu",
    style: "欧美风尚",
    photographer: "Nina Li",
    shootDate: "2026-02-11",
    hot: 8870,
    description:
      "丝绒面料在暖调灯光下泛着细腻光泽，一个回眸便撑起整张画面的戏剧感与高级感。",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20woman%20in%20a%20velvet%20dress%20looking%20back%2C%20warm%20amber%20studio%20lighting%2C%20dark%20neutral%20backdrop%2C%20luxury%20editorial%20portrait%2C%20high%20detail&width=800&height=1100&seq=bm-g08&orientation=portrait",
  },
  {
    id: "g09",
    title: "法式慵懒 · 落地窗前",
    category: "eu",
    style: "欧美风尚",
    photographer: "Nina Li",
    shootDate: "2026-01-28",
    hot: 7450,
    description:
      "法式风格的慵懒穿搭与大面积自然光结合，营造出不经意却讲究的优雅氛围。",
    image:
      "https://readdy.ai/api/search-image?query=french%20chic%20portrait%20of%20an%20elegant%20woman%20by%20a%20large%20window%2C%20soft%20diffused%20daylight%2C%20warm%20neutral%20interior%2C%20editorial%20photography%2C%20relaxed%20elegant%20mood%2C%20high%20detail&width=800&height=1100&seq=bm-g09&orientation=portrait",
  },
  {
    id: "g10",
    title: "海边微风 · 自由旅拍",
    category: "fresh",
    style: "清新自然",
    photographer: "叶舟",
    shootDate: "2026-04-16",
    hot: 9610,
    description:
      "海风、白裙与傍晚的暖光，记录一次说走就走的旅行。画面清爽干净，充满自由的呼吸感。",
    image:
      "https://readdy.ai/api/search-image?query=natural%20outdoor%20portrait%20of%20a%20young%20woman%20in%20a%20white%20dress%20by%20the%20seaside%2C%20golden%20hour%20sunlight%2C%20soft%20blue%20sky%20and%20sea%2C%20lifestyle%20photography%2C%20airy%20fresh%20mood%2C%20high%20detail&width=800&height=1100&seq=bm-g10&orientation=portrait",
  },
  {
    id: "g11",
    title: "绿意庭院 · 治愈午后",
    category: "fresh",
    style: "清新自然",
    photographer: "叶舟",
    shootDate: "2026-03-29",
    hot: 7030,
    description:
      "在满眼绿意的庭院里，用明亮通透的高调光线捕捉最自然的笑容，画面治愈而温暖。",
    image:
      "https://readdy.ai/api/search-image?query=bright%20natural%20portrait%20of%20a%20smiling%20young%20woman%20in%20a%20lush%20green%20garden%2C%20warm%20sunlight%2C%20fresh%20soft%20green%20background%2C%20healing%20lifestyle%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g11&orientation=portrait",
  },
  {
    id: "g12",
    title: "清晨窗光 · 素颜感",
    category: "fresh",
    style: "清新自然",
    photographer: "林浅",
    shootDate: "2026-02-19",
    hot: 5890,
    description:
      "以清晨的第一缕窗光为唯一光源，追求近乎素颜的自然质感，干净、真实、不刻意。",
    image:
      "https://readdy.ai/api/search-image?query=soft%20morning%20portrait%20of%20a%20young%20woman%20in%20bed%20near%20a%20window%2C%20gentle%20sunrise%20light%2C%20clean%20pale%20background%2C%20natural%20minimal%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g12&orientation=portrait",
  },
  {
    id: "g13",
    title: "旧时光 · 胶片质感",
    category: "retro",
    style: "复古典雅",
    photographer: "顾川",
    shootDate: "2026-01-07",
    hot: 8520,
    description:
      "使用胶片相机与暖调灯光，重现上世纪优雅的造型语言，颗粒感让画面充满时间的故事。",
    image:
      "https://readdy.ai/api/search-image?query=retro%20film%20portrait%20of%20a%20woman%20with%20vintage%20styling%2C%20warm%20amber%20tones%2C%20grainy%20analog%20texture%2C%20classic%20elegant%20interior%2C%20editorial%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g13&orientation=portrait",
  },
  {
    id: "g14",
    title: "红裙 · 剧院之光",
    category: "retro",
    style: "复古典雅",
    photographer: "顾川",
    shootDate: "2025-12-23",
    hot: 9140,
    description:
      "深红裙装与剧院暖光相映，戏剧性的明暗对比塑造出强烈的电影感与仪式感。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20woman%20in%20a%20deep%20red%20dress%20in%20a%20theater%2C%20warm%20dramatic%20stage%20lighting%2C%20dark%20elegant%20background%2C%20editorial%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g14&orientation=portrait",
  },
  {
    id: "g15",
    title: "旗袍 · 东方韵味",
    category: "retro",
    style: "复古典雅",
    photographer: "林浅",
    shootDate: "2025-12-05",
    hot: 7780,
    description:
      "以传统旗袍与中式庭院为载体，融合柔和的暖调光线，呈现含蓄而典雅的东方之美。",
    image:
      "https://readdy.ai/api/search-image?query=elegant%20oriental%20portrait%20of%20a%20woman%20in%20a%20classic%20qipao%20in%20a%20chinese%20courtyard%2C%20warm%20soft%20lighting%2C%20refined%20traditional%20background%2C%20editorial%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g15&orientation=portrait",
  },
  {
    id: "g16",
    title: "简约白衬衫 · 干练",
    category: "eu",
    style: "欧美风尚",
    photographer: "Sam Wu",
    shootDate: "2026-03-12",
    hot: 6650,
    description:
      "以一件剪裁利落的白衬衫为主线，用极简构图突出人物的自信与干练气质。",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20fashion%20portrait%20of%20a%20confident%20woman%20in%20a%20crisp%20white%20shirt%2C%20clean%20neutral%20studio%20backdrop%2C%20soft%20directional%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g16&orientation=portrait",
  },
  {
    id: "g17",
    title: "玻璃花房 · 光影游戏",
    category: "fresh",
    style: "清新自然",
    photographer: "苏念",
    shootDate: "2026-04-08",
    hot: 7320,
    description:
      "玻璃花房里透射的光线在林间与人物身上形成斑点状光影，营造出童话般的清新画面。",
    image:
      "https://readdy.ai/api/search-image?query=airy%20portrait%20of%20a%20young%20woman%20in%20a%20glass%20greenhouse%20full%20of%20plants%2C%20dappled%20sunlight%2C%20soft%20green%20tones%2C%20natural%20dreamy%20photography%2C%20high%20detail&width=800&height=1100&seq=bm-g17&orientation=portrait",
  },
  {
    id: "g18",
    title: "城市天台 · 落日时分",
    category: "street",
    style: "都市街拍",
    photographer: "何晏",
    shootDate: "2026-04-25",
    hot: 8750,
    description:
      "在天台等一场落日，用逆光剪影与暖橘色天空，记录城市年轻人独有的浪漫与自由。",
    image:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20woman%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20orange%20sky%2C%20backlit%20silhouette%2C%20urban%20lifestyle%20photography%2C%20cinematic%20mood%2C%20high%20detail&width=800&height=1100&seq=bm-g18&orientation=portrait",
  },
];